import React from "react";
import { Grid } from "@mui/material";
import {
  Box,
  Card,
  Container,
  Typography,
  Button,
  IconButton,
  makeStyles,
} from "@material-ui/core";
import { DataGrid, gridClasses } from "@mui/x-data-grid";

import booked from "../../../../assets/StatusImages/booked.gif";
import suspended from "../../../../assets/StatusImages/suspended.gif";
import injured from "../../../../assets/StatusImages/injured.png";
import unavailable from "../../../../assets/StatusImages/unavailable.png";
import available from "../../../../assets/StatusImages/available.png";
import selected from "../../../../assets/StatusImages/selected.png";
import sick from "../../../../assets/StatusImages/sick.png";

const useStyles = makeStyles({
  root: {
    fontSize: 20,
    "& .MuiDataGrid-row:nth-child(even)": {
      backgroundColor: "#FFFFFF",
    },
    "& .MuiDataGrid-row:nth-child(odd)": {
      backgroundColor: "#FBF3FF",
    },
  },
});

const pos = {
  Goalkeeper: "GK",
  Defender: "DEF",
  Midfielder: "MF",
  Forward: "FOR",
};
const Games = ({ players, head2headData }) => {
  console.log("players---------headGames", players, head2headData);

  const mainPath = "/lms/media/";

  const classes = useStyles();

  let leftPlayer = players.find(item => item.playerSeqNO === head2headData[0]);

  let rightPlayer = players.find(item => item.playerSeqNO === head2headData[1]);
  console.log("leftPlayer", head2headData[0], leftPlayer, head2headData[1], rightPlayer);

  // Player games list
  const games = [
    {
      name: "Full",
      lGame:
        leftPlayer.gamesInfo.full.gamesNo +
        " (" +
        leftPlayer.gamesInfo.full.minutes +
        ")",
      rGame:
        rightPlayer.gamesInfo.full.gamesNo +
        " (" +
        rightPlayer.gamesInfo.full.minutes +
        ")",
    },
    {
      name: "Ejected",
      lGame:
        leftPlayer.gamesInfo.eject.gamesNo +
        " (" +
        leftPlayer.gamesInfo.eject.minutes +
        ")",
      rGame:
        rightPlayer.gamesInfo.eject.gamesNo +
        " (" +
        rightPlayer.gamesInfo.eject.minutes +
        ")",
    },
    {
      name: "Sub-in",
      lGame:
        leftPlayer.gamesInfo.subIn.gamesNo +
        " (" +
        leftPlayer.gamesInfo.subIn.minutes +
        ")",
      rGame:
        rightPlayer.gamesInfo.subIn.gamesNo +
        " (" +
        rightPlayer.gamesInfo.subIn.minutes +
        ")",
    },
    {
      name: "Sub-out",
      lGame:
        leftPlayer.gamesInfo.subOut.gamesNo +
        " (" +
        leftPlayer.gamesInfo.subOut.minutes +
        ")",
      rGame:
        rightPlayer.gamesInfo.subOut.gamesNo +
        " (" +
        rightPlayer.gamesInfo.subOut.minutes +
        ")",
    },
    {
      name: "Sub-in-out",
      lGame:
        leftPlayer.gamesInfo.subInOut.gamesNo +
        " (" +
        leftPlayer.gamesInfo.subInOut.minutes +
        ")",
      rGame:
        rightPlayer.gamesInfo.subInOut.gamesNo +
        " (" +
        rightPlayer.gamesInfo.subInOut.minutes +
        ")",
    },
    {
      name: "Total",
      lGame:
        leftPlayer.gamesInfo.total.gamesNo +
        " (" +
        leftPlayer.gamesInfo.total.minutes +
        ")",
      rGame:
        rightPlayer.gamesInfo.total.gamesNo +
        " (" +
        rightPlayer.gamesInfo.total.minutes +
        ")",
    },
    {
      name: "Per Game",
      lGame: leftPlayer.gamesInfo.perGame,
      rGame: rightPlayer.gamesInfo.perGame,
    },
  ];

  const columns = [
    {
      field: "leftPlayerGames",
      width: 60,
      align: "center",
      renderCell: params => {
        return <Typography variant="h5">{params.value}</Typography>;
      },
    },
    {
      field: "games",
      width: 70,
      align: "center",
      renderCell: params => {
        return (
          <Typography variant="h4" style={{ fontWeight: 700 }}>
            {params.value}
          </Typography>
        );
      },
    },
    {
      field: "rightPlayerGames",
      width: 60,
      align: "center",
      renderCell: params => {
        return <Typography variant="h5">{params.value}</Typography>;
      },
    },
  ];

  const rows = games.map((game, id) => ({
    id: id,
    leftPlayerGames: game.lGame,
    games: game.name,
    rightPlayerGames: game.rGame,
  }));

  return (
    <div style={{ width: "100%" }}>
      <Grid
        container
        //  spacing={2}
        direction="row"
        justify="flex-start"
        alignItems="flex-start"
      >
        <Grid item xs={3} sm={3} md={3}>
          <Box>
            <Box mt={3} style={{ textAlign: "center" }}>
              <img
                style={{ width: 40, height: 40 }}
                src={
                  leftPlayer.playerId.headImage
                    ? mainPath + leftPlayer.playerId.headImage
                    : mainPath + "uploadedFiles/headImage/no-photo.png"
                }
              />
            </Box>
            <Box mr={0.5}>
              <Typography variant="h6" style={{ textAlign: "center", color: "#212121" }}>
                {leftPlayer.jerseyNO} {leftPlayer.playerId.name}
              </Typography>
            </Box>
            <Box mt={2}>
              <Typography
                variant="h6"
                style={{
                  textAlign: "center",
                  color: "#212121",
                }}
              >
                {leftPlayer.playerId.position}
              </Typography>
            </Box>
            <Box mt={1} style={{ textAlign: "center" }}>
              {leftPlayer.status === "Unavailable" && (
                <img
                  style={{ paddingLeft: 5, height: 20, marginBottom: -5 }}
                  src={unavailable}
                />
              )}
              {leftPlayer.status === "Fit" && (
                <img
                  style={{ paddingLeft: 5, height: 20, marginBottom: -5 }}
                  src={available}
                />
              )}
              {leftPlayer.status === "Booked" && (
                <img
                  style={{ paddingLeft: 7, height: 20, marginBottom: -5 }}
                  src={booked}
                />
              )}
              {leftPlayer.status === "Suspended" && (
                <img
                  style={{ paddingLeft: 7, height: 20, marginBottom: -5 }}
                  src={suspended}
                />
              )}
              {leftPlayer.status === "Injured" && (
                <img
                  style={{ paddingLeft: 5, height: 20, marginBottom: -5 }}
                  src={injured}
                />
              )}
              {leftPlayer.status === "Sick" && (
                <img
                  style={{ paddingLeft: 5, height: 20, marginBottom: -5 }}
                  src={sick}
                />
              )}
            </Box>
          </Box>
        </Grid>
        <Grid item xs={6} sm={6} md={6}>
          <div
            className={classes.root}
            style={{
              // marginRight: "20px",
              // marginLeft: "20px",
              marginTop: "20px",
            }}
          >
            <DataGrid
              rows={rows}
              columns={columns}
              autoHeight={true}
              hideFooter={true}
              rowHeight={48}
              headerHeight={0}
            />
          </div>
        </Grid>
        <Grid item xs={3} sm={3} md={3}>
          <Box>
            <Box mt={3} style={{ textAlign: "center" }}>
              <img
                style={{ width: 40, height: 40 }}
                src={
                  rightPlayer.playerId.headImage
                    ? mainPath + rightPlayer.playerId.headImage
                    : mainPath + "uploadedFiles/headImage/no-photo.png"
                }
              />
            </Box>
            <Box ml={0.5}>
              <Typography variant="h6" style={{ textAlign: "center", color: "#212121" }}>
                {rightPlayer.jerseyNO} {rightPlayer.playerId.name}
              </Typography>
            </Box>

            <Box mt={2}>
              <Typography
                variant="h6"
                style={{
                  textAlign: "center",
                  color: "#212121",
                }}
              >
                {rightPlayer.playerId.position}
              </Typography>
              <Box mt={1} style={{ textAlign: "center" }}>
                {rightPlayer.status === "Unavailable" && (
                  <img
                    style={{ paddingLeft: 5, height: 20, marginBottom: -5 }}
                    src={unavailable}
                  />
                )}
                {rightPlayer.status === "Fit" && (
                  <img
                    style={{ paddingLeft: 5, height: 20, marginBottom: -5 }}
                    src={available}
                  />
                )}
                {rightPlayer.status === "Booked" && (
                  <img
                    style={{ paddingLeft: 7, height: 20, marginBottom: -5 }}
                    src={booked}
                  />
                )}
                {rightPlayer.status === "Suspended" && (
                  <img
                    style={{ paddingLeft: 7, height: 20, marginBottom: -5 }}
                    src={suspended}
                  />
                )}
                {rightPlayer.status === "Injured" && (
                  <img
                    style={{ paddingLeft: 5, height: 20, marginBottom: -5 }}
                    src={injured}
                  />
                )}
                {rightPlayer.status === "Sick" && (
                  <img
                    style={{ paddingLeft: 5, height: 20, marginBottom: -5 }}
                    src={sick}
                  />
                )}
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </div>
  );
};

export default Games;
